var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.components[_vm.mod]
    ? _c(
        "div",
        { ref: "signup", class: "yxtbiz-signup " + _vm.mod },
        [
          _c(
            _vm.components[_vm.mod],
            _vm._g(
              _vm._b(
                {
                  ref: "refSignup",
                  tag: "component",
                  class: _vm.align === "center" ? "align-items-center" : "",
                },
                "component",
                Object.assign({}, _vm.$props),
                false
              ),
              Object.assign({}, _vm.$listeners)
            ),
            [
              _c("template", { slot: "content" }, [_vm._t("content")], 2),
              _c("template", { slot: "condition" }, [_vm._t("condition")], 2),
            ],
            2
          ),
          _c(
            "yxtf-dialog",
            {
              attrs: {
                "custom-class": "yxtbiz-signup " + _vm.dialogClass,
                "padding-size": _vm.dialogPaddingSize,
                title: _vm.dialogTitle,
                center: _vm.dialogCenter,
                visible: _vm.showDialog,
                width: _vm.dialogWidth + "px",
                cutline: _vm.dialogCutline,
                "append-to-body": true,
                "close-on-click-modal": false,
                "show-close": _vm.data.svgImgName ? false : true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.showDialog = $event
                },
                close: _vm.handleClose,
              },
            },
            [
              _vm.dialogType === "submit"
                ? _c(
                    "div",
                    {
                      class:
                        "align-center pt48 " +
                        (_vm.data.msg ? "pb24" : "pb48") +
                        " pl52 pr52",
                    },
                    [
                      _vm.data.svgImgName
                        ? _c(
                            "div",
                            { staticClass: "mb24" },
                            [
                              _vm.data.svgImgName === "tip"
                                ? _c("img", {
                                    staticClass: "inline-block w88 h88",
                                    attrs: { src: _vm.pendingIcon },
                                  })
                                : _c("yxtf-svg", {
                                    attrs: {
                                      width: "88px",
                                      height: "88px",
                                      "icon-class":
                                        "icons/f_feedback-" +
                                        _vm.data.svgImgName,
                                    },
                                  }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.data.title
                        ? _c("div", { staticClass: "c-cC26 fs24 fw500 hl32" }, [
                            _vm._v(_vm._s(_vm.data.title)),
                          ])
                        : _vm._e(),
                      _vm.data.info
                        ? _c("div", {
                            staticClass: "c-cC75 fs14 mt12",
                            domProps: { innerHTML: _vm._s(_vm.data.info) },
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "mt40" },
                        [
                          _c(
                            "yxt-button",
                            {
                              attrs: { size: "large", type: "primary" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.cancelCb.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.language().btn_view_my))]
                          ),
                          _vm.data.rangeEnrollCount > 0 &&
                          (_vm.data.allowEnrollCount > 0 ||
                            _vm.data.allowEnrollCount === -1) &&
                          _vm.data.svgImgName !== "warning"
                            ? _c(
                                "yxt-button",
                                {
                                  staticClass: "ml16",
                                  attrs: { size: "large" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.continueCb.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.language().txt_continue_signup)
                                  ),
                                ]
                              )
                            : _c(
                                "yxt-button",
                                {
                                  staticClass: "ml16",
                                  attrs: { size: "large" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.okCb.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.language().btn_view_details)
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                      _vm.data.msg
                        ? _c("pre", {
                            staticClass:
                              "bc-cCF5 pl16 pr16 pt16 pb16 rl4 rr4 rt4 rb4 align-left mt24",
                            domProps: { innerHTML: _vm._s(_vm.data.msg) },
                          })
                        : _vm._e(),
                    ]
                  )
                : _vm.dialogType === "cancel"
                ? _c(
                    "div",
                    { staticClass: "pl24 pr24" },
                    [
                      _vm.data.giveupTip
                        ? _c("span", { staticClass: "fs14 c-cC8C" }, [
                            _vm._v(_vm._s(_vm.data.giveupTip)),
                          ])
                        : _vm._e(),
                      _c("yxtf-input", {
                        staticClass: "mt16 mb14",
                        attrs: {
                          rows: 4,
                          type: "textarea",
                          placeholder: _vm.language().msg_text_reason,
                          maxlength: "200",
                        },
                        model: {
                          value: _vm.data.reason,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "reason", $$v)
                          },
                          expression: "data.reason",
                        },
                      }),
                    ],
                    1
                  )
                : _vm.dialogType === "userSelector"
                ? _c(
                    "div",
                    { staticClass: "fixed top0 left0 right0 bottom0 bc-cCFF" },
                    [
                      _c("user-selector", {
                        attrs: {
                          "audit-status-list": _vm.auditStatus,
                          max: _vm.data.max,
                        },
                        on: {
                          close: _vm.cancelCb,
                          sure: _vm.okCb,
                          getData: _vm.getData,
                        },
                      }),
                    ],
                    1
                  )
                : _vm.dialogType === "upload"
                ? _c("div", [
                    _c("div", { staticClass: "fs14 h24 c-cC8C mb16" }, [
                      _vm._v(
                        _vm._s(
                          _vm.language().msg_upload_info.replace(
                            "$types",
                            _vm.data.attachTypeOptionList
                              .map(function (_) {
                                return {
                                  1: _vm.language().lbl_file,
                                  2: _vm.language().lbl_picture,
                                  3: _vm.language().lbl_video,
                                }[_]
                              })
                              .join("、")
                          )
                        )
                      ),
                    ]),
                    _vm.data.attachments.length < _vm.uploadConfig.max
                      ? _c(
                          "div",
                          { staticClass: "wh120 center pointer" },
                          [
                            _c("yxtbiz-upload", {
                              staticClass: "wh120",
                              attrs: {
                                "icon-class": "plus",
                                filters: _vm.data.filters,
                                "config-key": "AttachConfigKey",
                                "app-code": "kng",
                                "module-name": "test_module",
                                "function-name": "test_function",
                                md5: "",
                                "before-upload": _vm.beforeUpload,
                                "on-progress": _vm.onProgress,
                                "on-uploaded": _vm.onUploaded,
                                "on-error": _vm.onError,
                                drag: true,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.data.attachments
                      ? _c(
                          "div",
                          { staticClass: "c-cC75 fs14 mt16" },
                          _vm._l(_vm.data.attachments, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                class:
                                  (index ? "mt8" : "") +
                                  " h40 lh40 bc-cCF5-hover rtl4 rtr4 rbl4 rbr4",
                              },
                              [
                                _c("yxtf-svg", {
                                  staticClass: "wh24 relative left-3 top4 ml8",
                                  attrs: {
                                    "icon-class":
                                      "icons/" +
                                      _vm.getIconName(item.fileClass),
                                  },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "fs14 c-cC26 relative top6 h20 inline-block ellipsis w148-max",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.name &&
                                          item.name.replace(/\.[^.]+$/, "")
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "fs14 c-cC8C relative top1" },
                                  [
                                    _vm._v(
                                      "." +
                                        _vm._s(
                                          item.name &&
                                            item.name.split(".").pop()
                                        )
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "fs14 c-cC8C ml8 relative top1",
                                  },
                                  [_vm._v(_vm._s(_vm.getSize(item.size)))]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "x-close fs14 c-cC8C ml8 pull-right mr16 pointer",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.close(item.uuid)
                                      },
                                    },
                                  },
                                  [
                                    _c("yxtf-svg", {
                                      staticClass: "relative top4",
                                      attrs: {
                                        width: "20px",
                                        height: "20px",
                                        "icon-class": "delete-1",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          !item.error && item.progress !== 100,
                                        expression:
                                          "!item.error && item.progress !== 100",
                                      },
                                    ],
                                    staticClass:
                                      "fs14 c-cC8C ml8 relative top2 mr18 pull-right wh159-40",
                                  },
                                  [
                                    _c(
                                      "yxtf-progress",
                                      {
                                        staticClass: "relative top-3",
                                        attrs: { percentage: item.progress },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "c-cC75",
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [_vm._v(_vm._s(item.progress) + "%")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  {
                                    class:
                                      "fs12 ml8 relative top1 pull-right mr12 w58 " +
                                      (!item.error ? "c-cC8C" : "c-cCRed"),
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.error
                                          ? _vm.language().lbl_upload_failed
                                          : item.progress === 100
                                          ? _vm.language().lbl_upload_success
                                          : _vm.language().lbl_uploading_now
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.dialogFooter
                ? _c(
                    "span",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c("yxtf-button", { on: { click: _vm.cancelCb } }, [
                        _vm._v(_vm._s(_vm.language().btn_cancel)),
                      ]),
                      _c(
                        "yxtf-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.okCb(_vm.data)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.language().btn_determine))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }